import { render, staticRenderFns } from "./NotificationsSidebar.vue?vue&type=template&id=ac85aa8a&"
import script from "./NotificationsSidebar.vue?vue&type=script&lang=ts&"
export * from "./NotificationsSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsSidebar.vue?vue&type=style&index=0&id=ac85aa8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports